import { ActionTypes } from '../../constants';

class ConfigActions {
  static addCpiConfig(config) {
    return {
      type: ActionTypes.ADD_CPI_CONFIG,
      payload: {
        cpiConfig: config,
      },
    };
  }
}

export default ConfigActions;
